import * as React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@estee/elc-buttons';
import { Field, Form, FormInput } from '@estee/elc-form';
import { Body2 } from '@estee/elc-typography';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';
import { MessagePanel } from '~views/common/MessagePanel';

import { QRCodeViewController } from './QRCodeViewController';

const classNames = classes('iam-thank-you-login');
const passwordClassNames = classes('iam-password-input');
const submitClassNames = classes('iam-submit-button');

export const QRCodeCreateOnlineAccForm = observer(() => {
    const qrCodeViewController = diContainer.get(
        serviceNames.qrCodeViewController
    ) as QRCodeViewController;

    const {
        data: { onlineSignUpFormStore, errorMessages, passwordValidations },
        submitButtonClicked
    } = qrCodeViewController;

    const {
        isSubmitting,
        values: { password }
    } = onlineSignUpFormStore;

    const { passwordLabel, submitLabel, loadingLabel, passwordHint } = useTranslation();

    const { isRequired, maxLength, validations } = passwordValidations;

    return (
        <div className={classNames}>
            <Form
                store={onlineSignUpFormStore}
                render={() => (
                    <>
                        <Field
                            name="password"
                            inputLabel={passwordLabel}
                            customClassName={passwordClassNames}
                            isRequired={isRequired}
                            maxLength={maxLength}
                            dataTestId="form_password"
                            component={FormInput}
                            validations={validations}
                            inputType="password"
                            showPasswordLabel="form_password"
                            showPasswordDataTestId="form_reveal_password"
                        />
                        {passwordHint && (
                            <Body2
                                dangerouslySetInnerHTML={{
                                    __html: passwordHint
                                }}
                            />
                        )}
                        {errorMessages && <MessagePanel messages={errorMessages} />}

                        <Button
                            disabled={isSubmitting || !!!password}
                            className={submitClassNames}
                            onClick={submitButtonClicked}
                        >
                            {isSubmitting ? loadingLabel : submitLabel}
                        </Button>
                    </>
                )}
            />
        </div>
    );
});
